import React from 'react';

interface Props {
    numReviews?: number;
    averageScore: number;
    noText?: boolean;
    orange?: boolean;
    hyperlink?: string;
}

const ReadReviews = (props: Props) => {
    const realAverageScore = props.averageScore !== undefined ? props.averageScore : 5;
    const roundedScore = Math.round(realAverageScore * 2) / 2;
    const scoreSummaryArray = [];
    for (let i = 1; i < 6; i++) {
        let icon = 'star_border';
        icon = i <= roundedScore ? 'star' : 'star_border';
        if (icon === 'star_border' && (Math.abs(realAverageScore - roundedScore) <= 0.5) && (Math.abs(i - roundedScore) <= 0.5)) {
            icon = 'star_half';
        }
        scoreSummaryArray.push(<i className="material-icons review__star" key={i} >{icon}</i>);
    }

    return (
        
        <a href={props.hyperlink} className="read-reviews">
            <div className="read-reviews__btn">
                <div className={`stars ${props.orange ? 'stars--orange' : ''} ${props.numReviews === 0 ? 'stars--disabled' : ''}`}>{scoreSummaryArray}</div>
                {!props.noText && <div className="count">({props.numReviews || '0'})</div>}
                <a href = {props.hyperlink + '?form=open'}>
                    <div className="text"><u>LEAVE A REVIEW</u></div>
                </a>
            </div>
        </a>
    );
}

export default ReadReviews;